import { useState } from 'react';
import { faqList } from '@/mocks/buzz';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="mx-auto w-full max-w-4xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <p className="font-display text-3xl text-leaf-500 md:text-4xl">常见问题</p>
        <h2 className="mt-2 text-2xl font-black leading-snug md:text-3xl">开吃之前，先看看这些</h2>
        <p className="mx-auto mt-2 max-w-lg text-sm leading-6 text-ink-soft md:text-base">
          关于更新节奏、内容原则与订阅方式，答案都在这里。
        </p>
      </div>

      <div className="mt-8 space-y-3">
        {faqList.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={i}
              className={`overflow-hidden rounded-2xl border bg-card transition-colors ${
                isOpen ? 'border-coral-200' : 'border-paper'
              }`}
            >
              <button
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <h3 className="text-sm font-bold text-ink md:text-base">{f.q}</h3>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? 'bg-coral-500 text-white' : 'bg-paper text-ink-soft'
                  }`}
                >
                  <i className={`text-sm ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`} />
                </span>
              </button>
              {isOpen && (
                <div className="px-5 pb-5">
                  <p className="border-l-2 border-coral-200 pl-4 text-sm leading-7 text-ink-soft">
                    {f.a}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}